module.exports = __webpack_public_path__ + "static/media/innerspaces2.f28adebb.jpg";